import { render, staticRenderFns } from "./OrderListDeliverySuccess.vue?vue&type=template&id=8e6d843a&scoped=true"
import script from "./OrderListDeliverySuccess.vue?vue&type=script&lang=js"
export * from "./OrderListDeliverySuccess.vue?vue&type=script&lang=js"
import style0 from "./OrderListDeliverySuccess.vue?vue&type=style&index=0&id=8e6d843a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6d843a",
  null
  
)

export default component.exports